export const mergeReorderedSubset = (
  fullOrder: string[],
  reorderedVisibleIds: string[]
): string[] => {
  const visibleSet = new Set(reorderedVisibleIds)
  let visibleIdx = 0

  return fullOrder.map((id) => {
    if (!visibleSet.has(id)) return id

    const replacement = reorderedVisibleIds[visibleIdx] ?? id
    visibleIdx++

    return replacement
  })
}
